var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsThumbsUpFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 21H8V8L15 1L16.25 2.25C16.37 2.36333 16.4667 2.52 16.54 2.72C16.6133 2.92 16.65 3.11333 16.65 3.3V3.65L15.55 8H21C21.5333 8 22 8.2 22.4 8.6C22.8 9 23 9.46667 23 10V12C23 12.1133 22.9867 12.24 22.96 12.38C22.9333 12.52 22.8967 12.6467 22.85 12.76L19.85 19.81C19.6967 20.1433 19.4467 20.4267 19.1 20.66C18.7533 20.8933 18.3867 21.0067 18 21ZM6 8V21H2V8H6Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsThumbsUpFilled);
export default __webpack_public_path__ + "static/media/icons_thumbs_up_filled.2a7e0444.svg";
export { ForwardRef as ReactComponent };